export const ROOT_NAME = '';
export const LAYOUT_NAME = 'dashboard';
export const CASES_NAME = 'casos';
export const PRE_SIMULATOR_NAME = 'pre-simulador';
export const HOME_NAME = '';
export const LOGIN_NAME = 'login';
export const LOGIN_SECOND_HOLDER = 'login-segundo-titular';
export const SUMMARY_SECOND_HOLDER = 'resumen-segundo-titular';
export const ERROR_NAME = 'error';
export const ECONOMIC_STUDY_NAME = 'estudio-economico';
export const DOCUMENTATION_NAME = 'documentacion';
export const APPRAISAL_NAME = 'tasacion';
export const SIGN_IN_NAME = 'firma';
export const RESULT_NAME = 'resultado';
export const WALL_NAME = 'tus-mensajes';
export const X_USER_HEADER = 'X-User';
export const CACHE_USER_DATA_KEY = 'cache_user_data';
export const GENERAL_PARAMS_KEY = 'general_params';

export const ROOT_URL = `/${ROOT_NAME}`;
export const CASES_URL = `/${CASES_NAME}`;
export const PRE_SIMULATOR_URL = `/${PRE_SIMULATOR_NAME}`;
export const HOME_URL = `/${HOME_NAME}`;
export const ERROR_URL = `/${ERROR_NAME}`;
export const LAYOUT_ERROR_URL = `/${LAYOUT_NAME}/${ERROR_NAME}`;
export const LAYOUT_URL = `/${LAYOUT_NAME}`;
export const RESULT_URL = `/${LAYOUT_NAME}/${RESULT_NAME}`;
export const DOCUMENTATION_URL = `/${LAYOUT_NAME}/${DOCUMENTATION_NAME}`;
export const ECONOMIC_STUDY_URL = `/${LAYOUT_NAME}/${ECONOMIC_STUDY_NAME}`;
export const APPRAISAL_URL = `/${LAYOUT_NAME}/${APPRAISAL_NAME}`;
export const SIGN_IN_URL = `/${LAYOUT_NAME}/${SIGN_IN_NAME}`;
export const WALL_IN_URL = `/${LAYOUT_NAME}/${WALL_NAME}`;
export const SUMMARY_SECOND_HOLDER_URL = `/${LAYOUT_NAME}/${SUMMARY_SECOND_HOLDER}`;

export const EMAIL_REGEXP =
  /^[a-zA-Z0-9_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}?$/;
export const ES_MOBILE_PHONE_REGEXP = /^[67]{1}[0-9]{8}$/;
export const ES_PHONE_REGEXP = /^[6789]{1}[0-9]{8}$/;
export const ES_POSTAL_CODE_REGEXP = /^0[1-9][0-9]{3}|[1-4][0-9]{4}|5[0-2][0-9]{3}/;

export const VALIDATORS_LENGTH = {
  minLength: 3,
  maxLength: {
    default: 25,
    cityName: 80,
    roadName: 50,
    ownerName: 50,
    roadNumber: 4,
    doorway: 2,
    floor: 3,
    door: 2,
    generic: 200,
    reference: 23,
    membersFamily: 2,
    squareMeters: 4,
    phone: 9,
    companyName: 80,
    email: 80,
    registry: 30,
    registryNumber: 30,
    farmNumber: 30,
    volume: 30,
    book: 30,
    folio: 30,
    idufir: 40,
  },
};

export const VALIDATED_COD = 'REVIEW_DOC_ADMITTED';
export const VALIDATED_OBS_COD = 'REVIEW_DOC_OBSERVATION';
export const PENDING_COD = 'REVIEW_DOC_PENDING';

export const SESSIONSTORAGE_TOKEN = 'token';

export const TRANSLATION_OBJECT_KEY = `TRANSLATION_OBJECT_`;
export const TRANSLASTION_TIMESTAMP_KEY = `TRANLASTION_TIMESTAMP_`;

export const MIN_STATUS = {
  saveData: 1,
  simulation_done: 4,
  simulation_done_subtype_1: 1,
  simulation_done_subtype_2: 2,
  waitingAceptedSecondHolder: 4.3,
  modifyDataSecondHolder: 4.4,
  refuseSecondHolder: 4.5,
  attachDocumentation: 5,
  finalizeAttachDocumentation: 5.5,
  validatingDocumentation: 6,
  appraisal: 7,
  appraisal_done: 8,
  signature: 9,
  inscription: 10,
};

export const DOC_CATEGORY = {
  appraisal: 'MTG_C04',
};

export const TPV_CURRENCY = 'EUR';
export const TPV_TRANSACTION_TYPE = '7';
